<template>
  <fieldset class="step step--1">
    <Section title="Użytkownik">
      <CertificationFormGroup name="fullname" :can-moderate="false">
        <InputControl
          id="organiser-name"
          v-model="form.name"
          number="1"
          label="Użytkownik"
          :disabled="true"
          :inline="true"
        />
      </CertificationFormGroup>

      <CertificationFormGroup name="email" :can-moderate="false">
        <InputControl
          id="email"
          v-model="form.email"
          number="2"
          label="Email"
          :disabled="true"
          :inline="true"
        />
      </CertificationFormGroup>
    </Section>

    <Section title="Wydarzenie">
      <CertificationFormGroup name="hasProgramme">
        <TrueFalseControl
          id="has-programme-type"
          v-model="form.hasProgramme"
          number="3"
          :get-object="false"
          label="Na etapie wypełniania niniejszego wniosku dostępny jest co najmniej program ramowy wydarzenia"
          help="Program zawierający co najmniej ramy czasowe wydarzenia oraz tematykę/zagadnienia poszczególnych sesji"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
      <CertificationFormGroup v-show="false" name="isOther">
        <TrueFalseControl
          id="is-other-type"
          v-model="form.isOther"
          number="4"
          :get-object="false"
          label="Zgłaszane wydarzenie ma charakter wydarzenia wyłącznie okołosystemowego/ogólnosystemowego, dotyczy funkcjonowania systemu ochrony zdrowia"
          help="BRAKUJE DEFINICJI"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
      <CertificationFormGroup name="isInternal">
        <TrueFalseControl
          id="is-internal-type"
          v-model="form.isInternal"
          number="4"
          :get-object="false"
          label="Wydarzenie jest wydarzeniem firmowym"
          help="Wydarzenie w całości lub w części organizowane przez firmy członkowskie (Izby POLMED lub MedTech Polska) lub w ich imieniu."
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
      <CertificationFormGroup name="international">
        <RadioControl
          id="international-type"
          v-model="form.international"
          :options="internationalType"
          number="5"
          :get-object="false"
          label="Wydarzenie ma zasięg"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
    </Section>

    <transition name="slide-fade">
      <Section v-show="stepEnabled" title="Podmiot zgłaszający">
        <CertificationFormGroup name="applicant" :can-moderate="false">
          <SelectControl
            v-if="!isAdmin"
            id="applicant-name"
            v-model="form.applicant"
            label="Podmiot zgłaszający"
            :options="applicantOrganizations"
            :inline="true"
            :allow-empty="false"
            number="6"
            :disabled="true"
            @update:item="form.applicant = $event"
          />

          <InputControl
            v-if="isAdmin"
            id="applicant-name"
            v-model="form.applicant.name"
            label="Podmiot zgłaszający"
            :inline="true"
            number="6"
            :disabled="formDisabled"
          />
        </CertificationFormGroup>

        <CertificationFormGroup name="applicant.type">
          <template slot-scope="{ validator }">
            <SelectControl
              id="organiser-type"
              v-model="form.applicant.type"
              :options="applicantType"
              :get-object="false"
              label="Określ swój status wobec zgłaszanego wydarzenia: jestem organizatorem "
              help="<p><strong>Organizator logistyczny</strong> – podmiot organizujący wydarzenie, odpowiedzialny za sferę logistyczną lub organizacyjną, w tym PCO lub HCO.</p>
              <p><strong>Organizator merytoryczny</strong> – podmiot organizujący wydarzenie, odpowiedzialny za sferę merytoryczną, w tym PCO lub HCO.</p>"
              :inline="true"
              number="7"
              :disabled="formDisabled"
              @input="organizationTypeSelected(validator)"
            />
          </template>
        </CertificationFormGroup>
        <CertificationFormGroup
          v-show="['essential', 'both'].indexOf(form.applicant.type) !== -1"
          :name="`applicant.nonBusiness`"
        >
          <TrueFalseControl
            :id="'applicant-business'"
            v-model="form.applicant.nonBusiness"
            number="8"
            label="Organizator merytoryczny jest osobą fizyczną lub osobą fizyczną prowadzącą działalność gospodarczą"
            :inline="true"
            :disabled="formDisabled"
          />
        </CertificationFormGroup>

        <CertificationFormGroup
          v-show="['logistic'].indexOf(form.applicant.type) !== -1"
          :name="`applicant.authorized`"
        >
          <TrueFalseControl
            :id="'applicant-authorized'"
            v-model="form.applicant.authorized"
            number="8"
            label="Organizator logistyczny działa z upoważnienia organizatora merytorycznego"
            :inline="true"
            :disabled="formDisabled"
          />
        </CertificationFormGroup>

        <Section
          title="Organizatorzy"
          description="Wymień wszystkich pozostałych organizatorów"
        >
          <CertificationFromOrganisers
            id="organisers"
            v-model="form.organizations"
            :disabled="formDisabled"
          />
        </Section>
      </Section>
    </transition>

    <transition name="slide-fade">
      <div v-show="warningText.length">
        <BAlert variant="warning" show class="form__warning-text">
          <p
            v-for="(warning, idx) in warningText"
            :key="idx"
            v-html="warning"
          ></p>
        </BAlert>
      </div>
    </transition>

    <transition name="slide-fade">
      <div v-show="alertText.length">
        <BAlert variant="danger" show class="form__alert-text">
          <p v-for="(alert, idx) in alertText" :key="idx" v-html="alert"></p>
        </BAlert>
      </div>
    </transition>
  </fieldset>
</template>

<script>
import BaseCertificationFormStep from "@/components/Base/Certification/BaseCertificationFormStep";
import Section from "@/components/Elements/Section";
import InputControl from "@/components/Controls/InputControl";
import SelectControl from "@/components/Controls/SelectControl";
import TrueFalseControl from "@/components/Controls/TrueFalseControl";
import CertificationFromOrganisers from "./CertificationFormOrganisers";
import RadioControl from "@/components/Controls/RadioControl";

import { internationalType } from "./data";

import { mapState, mapGetters } from "vuex";
import { applicantType } from "./data";

import ModelFactory from "@/model/ModelFactory";

export default {
  name: "CertificationFormStep1",
  components: {
    InputControl,
    SelectControl,
    CertificationFromOrganisers,
    Section,
    TrueFalseControl,
    RadioControl
  },
  extends: BaseCertificationFormStep,
  data() {
    return {
      applicantType,
      internationalType,
      applicantOrganizations: []
    };
  },

  computed: {
    ...mapState("User", ["user"]),
    ...mapGetters("User", ["getActiveOrganizations", "isAdmin"]),
    allOrganizations: function() {
      return [...[this.form.applicant], ...this.form.organizations];
    },
    organisersAuthorised: function() {
      return (
        this.allOrganizations.filter(
          organization => !organization.isAuthorized()
        ).length == 0
      );
    },
    organisersBusiness: function() {
      return (
        this.allOrganizations.filter(organization => !organization.isBusiness())
          .length === 0
      );
    },
    hasLogisticOrganiser() {
      return (
        this.allOrganizations.filter(organization => organization.isLogistic())
          .length > 0
      );
    },
    hasEssentialOrganiser() {
      return (
        this.allOrganizations.filter(organization => organization.isEssential())
          .length > 0
      );
    },
    hasBothOrganiserTypes() {
      return this.hasLogisticOrganiser && this.hasEssentialOrganiser;
    },
    alertText() {
      let alertText = [];
      if (this.form.applicant.type === "none") {
        alertText.push(
          "Wydarzenie może być zgłoszone tylko przez organizatora merytorycznego lub logistycznego"
        );
      }

      if (this.form.international === "international") {
        alertText.push(
          'Wydarzenia międzynarodowe nie podlegają weryfikacji w niniejszym systemie. Należy zgłosić je do weryfikacji w systemie CVS na platformie <a href="https://www.ethicalmedtech.eu" target="_blank">www.ethicalmedtech.eu</a>'
        );
      }
      if (this.form.hasProgramme === false) {
        alertText.push(
          "Do złożenia wniosku o ocenę wydarzenia konieczne jest dostarczenie co najmniej programu ramowego."
        );
      }
      if (this.form.isOther === true) {
        alertText.push(
          "Wydarzanie o charakterze niezwiązanym z (ucięty tekst w Wordzie)"
        );
      }
      if (this.form.isInternal === true) {
        alertText.push(
          "wydarzenia firmowe nie podlegają weryfikacji w niniejszym systemie."
        );
      }
      if (!this.organisersAuthorised) {
        alertText.push(
          "Organizatorzy logistyczni muszą działać z upoważnienia organizatora merytorycznego"
        );
      }
      if (
        !this.hasBothOrganiserTypes &&
        this.form.applicant.type &&
        this.form.applicant.type !== "both"
      ) {
        alertText.push(
          "Wydarzenie musi mieć organizatora merytorycznego i logistycznego"
        );
      }
      return alertText;
    },
    warningText() {
      let warningText = [];
      if (
        this.form.applicant.nonBusiness === true ||
        !this.organisersBusiness
      ) {
        warningText.push(
          "Organizatorem merytorycznym wydarzenia nie może być osoba fizyczna lub osoba fizyczna prowadzącą działalność gospodarczą.<br/>Możesz dokończyć zgłoszenie, ale oceniający podejmie decyzję czy zostanie ono poddane weryfikacji."
        );
      }

      return warningText;
    },

    stepEnabled() {
      return (
        this.form.international !== null &&
        this.form.international !== "international" &&
        this.form.hasProgramme !== null &&
        this.form.isOther !== null &&
        this.form.isInternal !== null
      );
    },
    formEnabled() {
      return (
        this.stepEnabled &&
        this.alertText.length == 0 &&
        this.hasBothOrganiserTypes
      );
    }
  },
  watch: {
    "form.applicant": function(newValue) {
      if (!newValue) {
        this.form.applicant = ModelFactory.create("OrganizationModel");
      }
    },
    "form.applicant.type": function(newValue) {
      if (newValue == "logistic") {
        this.form.applicant.nonBusiness = null;
      } else if (["essential", "both"].includes(newValue)) {
        this.form.applicant.authorized = null;
      }
    },
    form: {
      deep: true,
      handler: function() {
        this.enableForm();
      }
    }
  },
  created() {
    this.$store.dispatch("Form/disableAllSteps");
    this.enableForm();
    // this.$store.dispatch("User/getCurrent").then(() => {
    let orgs = [];
    this.getActiveOrganizations.forEach(item =>
      orgs.push(ModelFactory.create("OrganizationModel", { ...item }))
    );
    this.$set(this, "applicantOrganizations", orgs);
    // });
  },
  methods: {
    enableForm() {
      // setTimeout(() => this.$store.dispatch("Form/enableAllSteps"), 200);

      // this.$store.dispatch("Form/enableStep", 2);

      if (this.form.id > 0) {
        this.$store.dispatch("Form/enableAllSteps");
      } else if (this.formEnabled) {
        this.$store.dispatch("Form/enableStep", 2);
      } else {
        this.$store.dispatch("Form/disableStep", 2);
      }
    },
    organizationTypeSelected(validator) {
      this.touch(validator);
    }
  }
};
</script>

<style lang="scss">
.form__warning-text,
.form__alert-text {
  margin-top: 20px;
}
.form__warning-text p,
.form__alert-text p {
  margin-bottom: 8px;
}
.form__warning-text p:last-child,
.form__alert-text p:last-child {
  margin-bottom: 0;
}
</style>
